
import Vue from "vue";
import AppContainer from "@/components/login/LoginContainer.vue";
import AppTitle from "@/components/login/LoginTitle.vue";
import AppText from "@/components/login/LoginText.vue";
import AppSection from "@/components/login/LoginSection.vue";
import { ExactService } from "@/services/exact-service";

export default Vue.extend({
	data() {
		return {
			status: "",
			error: ""
		};
	},
	async mounted() {
		let splashEl = document.getElementById("splash");
		if (splashEl) splashEl.remove();

		this.status = this.$ct("connecting").toString();

		let code = this.$route.query.code as string;
		if (!code) {
			this.status = this.$ct("no-code-title").toString();
			this.error = this.$ct("no-code-detail").toString();
			return;
		}
		try {
			await ExactService.exchangeCode(code);
			this.status = this.$ct("success").toString();
			setTimeout(() => this.$router.push("/portal/settings"), 1000);
		} catch (err) {
			this.status = this.$ct("failed").toString();
			this.error = (err as any)?.message || this.$ct("unknown-error").toString();
		}
	},
	components: {
		AppContainer,
		AppTitle,
		AppText,
		AppSection
	},
	i18nEx: {
		componentPrefix: "views.ExactConnectRedirect"
	}
});
